import { DisplayPosition } from '@/common/manager/position/display-position';
const CnFormGrid = 'CnFormGrid';
export const config = {
    position: [DisplayPosition.formDialog, DisplayPosition.form],
    componentName: 'CnFormTabItem',
    isFormContainer: true,
    allowParentList: ['root'],
    formItemBeforeHandler: (formItem, config) => {
        const { formItemConfig = {}, formProps = {} } = config || {};
        const { formStyle = {} } = formProps;
        const { cols } = formStyle || {};
        if (formItem) {
            const { label, name } = formItemConfig;
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                if (label && !componentProps.title) {
                    componentProps.title = label;
                }
            }
            delete formItem['x-decorator'];
            formItem.properties = {};
            formItem.title = '';
            formItem.type = 'void';
            const { cols: cardCols } = componentProps;
            const formGridProps = {};
            if (cardCols) {
                formGridProps.cols = cardCols;
            }
            else {
                formGridProps.cols = cols;
            }
            formItem.properties = {
                [`${name}_${CnFormGrid}`]: {
                    type: 'void',
                    'x-component': CnFormGrid,
                    'x-component-props': formGridProps,
                    properties: {},
                },
            };
        }
    },
};
